import { defineRecipe } from '@chakra-ui/react';

export const buttonRecipe = defineRecipe({
  base: {
    colorPalette: 'navy',
    fontWeight: 400,
    fontSize: 'md',
  },
  variants: {
    variant: {
      outline: {
        _icon: {
          color: 'colorPalette.solid',
        },
      },
      solid: {
        _icon: {
          // `_icon` is `:where(svg)`, so the icon recipe outranks it without this.
          color: 'colorPalette.contrast !important',
        },
      },
      link: {
        _icon: {
          color: 'colorPalette.solid',
        },
      },
    },
  },
});

export default buttonRecipe;
